import mapValues from 'lodash-es/mapValues'
import type { Breakpoints } from './types'

export const breakpoints: Breakpoints = {
  mobileM: 375,
  tablet: 768,
  laptopS: 992,
  laptop: 1280,
  desktop: 1920,
}

export const mediaQueriesExpressions = mapValues(breakpoints, (item) => {
  return `(min-width: ${item}px)`
})

export const mediaQueries = mapValues(mediaQueriesExpressions, (item) => {
  return `@media ${item}`
})
